import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影视剪辑", to: "/category/film" },
  { label: "短视频", to: "/category/short" },
  { label: "情感专辑", to: "/category/emotional" },
  { label: "专题", to: "/#specials" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    if (to.startsWith("/#")) return false;
    return location.pathname.startsWith(to);
  };

  const handleSpecial = () => {
    setMenuOpen(false);
    navigate("/");
    setTimeout(() => {
      document.getElementById("specials")?.scrollIntoView({ behavior: "smooth" });
    }, 120);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg" />
          </div>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
            亲嘴视频
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) =>
            item.to.startsWith("/#") ? (
              <button
                key={item.to}
                onClick={handleSpecial}
                className="px-4 py-2 text-sm rounded-md text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </button>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  isActive(item.to)
                    ? "text-primary-600 bg-primary-50 font-medium"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                }`}
              >
                {item.label}
              </Link>
            )
          )}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            aria-label="搜索"
            className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-lg" />
          </Link>
          <button
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4 pt-2 animate-fade-in">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) =>
              item.to.startsWith("/#") ? (
                <button
                  key={item.to}
                  onClick={handleSpecial}
                  className="text-left px-4 py-3 rounded-md text-sm text-foreground-700 hover:bg-primary-50 transition-colors cursor-pointer"
                >
                  {item.label}
                </button>
              ) : (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-3 rounded-md text-sm transition-colors cursor-pointer ${
                    isActive(item.to)
                      ? "text-primary-600 bg-primary-50 font-medium"
                      : "text-foreground-700 hover:bg-primary-50"
                  }`}
                >
                  {item.label}
                </Link>
              )
            )}
          </nav>
        </div>
      )}
    </header>
  );
}